import { testimonials } from '@/mocks/home';

export default function Testimonials() {
  return (
    <section className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="w-full">
        <div className="max-w-2xl mb-12">
          <span className="font-heading text-sm tracking-widest text-primary-600">投稿人怎么说</span>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-950 leading-tight">
            投稿过的人，后来还愿意再投一次
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col p-6 rounded-lg bg-background-50 border border-background-200"
            >
              <i className="ri-double-quotes-l text-3xl text-accent-400"></i>
              <blockquote className="mt-4 text-sm leading-7 text-foreground-700 flex-1">{t.quote}</blockquote>
              <figcaption className="mt-6 pt-5 border-t border-background-200 flex items-center gap-3">
                <span className="w-11 h-11 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img src={t.avatar} alt={`${t.name}的头像`} className="w-full h-full object-cover object-top" />
                </span>
                <span className="flex flex-col">
                  <span className="text-sm font-bold text-foreground-950">{t.name}</span>
                  <span className="text-xs text-foreground-500">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}